var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirtime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.264648,
    width: 57,
    height: 57,
    rx: 12,
    fill: "#BCE2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5708 11.1947C29.2814 10.9991 28.9401 10.8945 28.5908 10.8945C28.2415 10.8945 27.9002 10.9991 27.6108 11.1947C27.0858 11.5447 15.0283 19.9447 15.0283 32.3347C15.0283 35.9317 16.4572 39.3813 19.0007 41.9248C21.5441 44.4683 24.9938 45.8972 28.5908 45.8972C32.1878 45.8972 35.6375 44.4683 38.181 41.9248C40.7244 39.3813 42.1533 35.9317 42.1533 32.3347C42.1533 19.7347 30.0783 11.5272 29.5708 11.1947ZM28.5908 42.3972C25.9235 42.3925 23.3668 41.3309 21.4807 39.4448C19.5946 37.5587 18.5329 35.002 18.5283 32.3347C18.5283 23.5847 25.8958 16.9872 28.5908 14.8347C31.3033 16.9522 38.6533 23.5847 38.6533 32.3347C38.6487 35.002 37.5871 37.5587 35.701 39.4448C33.8149 41.3309 31.2581 42.3925 28.5908 42.3972Z",
    fill: "#0B0A0A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.764648,
    y: 0.5,
    width: 56,
    height: 56,
    rx: 11.5,
    stroke: "black",
    strokeOpacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtime);
export default __webpack_public_path__ + "static/media/airtime.d867e85edfb921571355147ee9b0ac59.svg";
export { ForwardRef as ReactComponent };